module.exports = __webpack_public_path__ + "media/red-tailed-hawk-1.149a2c9a.mp3";